import { ApolloError } from '@apollo/client';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Try again.';

/**
 * Surfaces the most useful error string for a toast: the first GraphQL error
 * message when the failure came from AppSync, else the JS `Error.message`,
 * else a safe default. Callers pass the caught value straight through so we
 * never re-throw with a bare `Try updating…` message.
 */
export const extractErrorMessage = (error: unknown): string => {
  if (error instanceof ApolloError) {
    const gql = error.graphQLErrors?.[0]?.message;
    if (gql) return gql;
    if (error.message) return error.message;
    return DEFAULT_ERROR_MESSAGE;
  }
  if (error instanceof Error && error.message) return error.message;
  return DEFAULT_ERROR_MESSAGE;
};
